import { axiosService } from "./axiosService";

const eventApi = {
    get() {
        const url = '/event';
        return axiosService.get(url)
    },
    create(body) {
        const url = '/event';
        return axiosService.post(url, body)
    },
}

export default eventApi;